import { render, staticRenderFns } from "./CenterViewUpload_Ap.vue?vue&type=template&id=36305b03&scoped=true"
import script from "./CenterViewUpload_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewUpload_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewUpload_Ap.vue?vue&type=style&index=0&id=36305b03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36305b03",
  null
  
)

export default component.exports